// Module
var code = "<div class=\"beta-flag\"><span>BETA</span><span>BETA</span></div> ";
// Exports
module.exports = code;